// import { hashCode } from '@unhead/shared';

export default defineNuxtPlugin(nuxtApp => {
  const current: string | undefined = nuxtApp.payload?.config?.public?.baseUrl;
  if (current) {
    const parts: string[] = current.split('/');
    if (parts.length === 4 && nuxtApp.payload.config) {
      parts.pop();
      nuxtApp.payload.config.public.baseUrl = parts.join('/');
    }
  }

  if (!process.server) {
    document
      .querySelectorAll<HTMLLinkElement>('head link[rel=alternate]')
      .forEach((e: HTMLLinkElement) => {
        if (e.hreflang && e.hreflang.length === 2) {
          // e.dataset.hid = hashCode(`i18n-alt-${e.hreflang}`);
        }
      });
  }
});
